export default "__VITE_ASSET__CSg8$rUr__"